(() => {
window.api = {};
const $218703de6b4a0d50$var$api = window.api;
// api.host = window.location.hostname; // Dev
$218703de6b4a0d50$var$api.base_url = "/api/";
$218703de6b4a0d50$var$api.DEBUG = false;
$218703de6b4a0d50$var$api.get = function(api_url, candidate_token = false, options) {
    if ($218703de6b4a0d50$var$api.DEBUG) console.log("API URL: " + api_url);
    return fetch($218703de6b4a0d50$var$api.base_url + api_url, {
        ...options,
        method: "GET",
        headers: {
            Authorization: "Bearer " + getCookie(candidate_token ? "candidate_session_token" : "session_token")
        }
    });
};
$218703de6b4a0d50$var$api.post = function(api_url, post_params, candidate_token = false) {
    return fetch($218703de6b4a0d50$var$api.base_url + api_url, {
        method: "POST",
        body: JSON.stringify(post_params),
        headers: {
            Authorization: "Bearer " + getCookie(candidate_token ? "candidate_session_token" : "session_token")
        }
    });
};
$218703de6b4a0d50$var$api.put = function(api_url, put_params, candidate_token = false) {
    return fetch($218703de6b4a0d50$var$api.base_url + api_url, {
        method: "PUT",
        body: JSON.stringify(put_params),
        headers: {
            Authorization: "Bearer " + getCookie(candidate_token ? "candidate_session_token" : "session_token")
        }
    });
};
$218703de6b4a0d50$var$api.delete = function(api_url, candidate_token = false) {
    return fetch($218703de6b4a0d50$var$api.base_url + api_url, {
        method: "DELETE",
        headers: {
            Authorization: "Bearer " + getCookie(candidate_token ? "candidate_session_token" : "session_token")
        }
    });
};
$218703de6b4a0d50$var$api.fill_dropdown = function(dropdown_selector) {
    return function(response) {
        const names = response.payload;
        $(dropdown_selector).find('option[value!=""]').remove();
        let options = $(dropdown_selector).html();
        for(id in names)options += '<option value="' + id + '">' + names[id] + "</option>";
        $(dropdown_selector).html(options);
    };
};
$218703de6b4a0d50$var$api.user_avatar_url = function(user_id) {
    return "/user/avatar/" + user_id;
};
// Converts a JS object into a string that the API will understand
$218703de6b4a0d50$var$api.format = function(obj) {
    console.log(obj);
    if (typeof obj === "undefined") return;
    if (obj instanceof Date) return obj.getFullYear() + "-" + (obj.getMonth() + 1) + "-" + (obj.getDay() + 1);
    if (typeof obj === "string") // Replace underscores with spaces
    return obj.replace(/_/g, " ");
    if (obj.toString) return obj.toString();
};
// Converts a parameter object into a URI search string
// Runs every value through api.format and uses its key as the search parameter name
$218703de6b4a0d50$var$api.params_to_search = function(params) {
    const newParams = {};
    for(const item in params){
        if (typeof params[item] === "undefined") continue;
        newParams[item] = $218703de6b4a0d50$var$api.format(params[item]);
    }
    return "?" + new URLSearchParams(newParams).toString();
};
// Parameters
// start_date - date
// end_date - date
// state - 2-character state abbreviation or state ID
// county - name or ID
// city - name with spaces or ID
// zip
// include_candidates
$218703de6b4a0d50$var$api.search_elections = function(params) {
    const search_string = $218703de6b4a0d50$var$api.params_to_search(params);
    return $218703de6b4a0d50$var$api.get(decodeURIComponent("elections" + search_string)).then((response)=>response.json());
};
// Parameters
// start_date
// end_date
// zip
// state
// government_level_id
$218703de6b4a0d50$var$api.get_election_counts_by_zip = function(params) {
    const search_string = $218703de6b4a0d50$var$api.params_to_search(params);
    return $218703de6b4a0d50$var$api.get(decodeURIComponent("election/counts_by_zip/" + search_string)).then((response)=>response.json());
};
// Parameters
// start_date
// end_date
// state
// government_level_id
$218703de6b4a0d50$var$api.get_election_counts_by_state = function(params) {
    const search_string = $218703de6b4a0d50$var$api.params_to_search(params);
    return $218703de6b4a0d50$var$api.get(decodeURIComponent("election/counts_by_state/" + search_string)).then((response)=>response.json());
};
// Parameters
// start_date
// end_date
// state
// county_id
// government_level_id
$218703de6b4a0d50$var$api.get_election_counts_by_county = function(params) {
    const search_string = $218703de6b4a0d50$var$api.params_to_search(params);
    return $218703de6b4a0d50$var$api.get(decodeURIComponent("election/counts_by_county/" + search_string)).then((response)=>response.json());
};
// Parameters
// code
$218703de6b4a0d50$var$api.get_counties_for_state_by_code = function(params, options) {
    const code = params.code;
    return $218703de6b4a0d50$var$api.get(decodeURIComponent("county/by_state/" + code), false, options).then((response)=>response.json());
// .catch( err => {
// 	console.warn('API error: ', err)
// });
};
$218703de6b4a0d50$var$api.get_states = function() {
    return $218703de6b4a0d50$var$api.get(decodeURIComponent("states")).then((response)=>response.json());
};
// Parameters
// state
// county
// name
$218703de6b4a0d50$var$api.city_search = function(params) {
    const search_string = $218703de6b4a0d50$var$api.params_to_search(params);
    return $218703de6b4a0d50$var$api.get(decodeURIComponent("cities" + search_string)).then((response)=>response.json());
};
// Parameters
// start_date
// end_date
// city (name or id. If name, must be exact match)
// state (required if specifying by name)
// government_level_id
$218703de6b4a0d50$var$api.get_election_counts_by_city = function(params) {
    console.log("params", params);
    const search_string = $218703de6b4a0d50$var$api.params_to_search(params);
    console.log("search_string", search_string);
    return $218703de6b4a0d50$var$api.get(decodeURIComponent("election/counts_by_city" + search_string)).then((response)=>response.json());
};
// Dummy function for an unimplemented API call
// TODO: Hook this up to the API when the call is finshed
$218703de6b4a0d50$var$api.get_schoolbards = function(params) {
    const dummy_data = {
        status: 200,
        payload: [
            {
                id: 1010,
                name: "test board 1010"
            },
            {
                id: 1011,
                name: "test board 1011"
            },
            {
                id: 1100,
                name: "test board 1100"
            }
        ]
    };
    return Promise.resolve(dummy_data);
};

})();
//# sourceMappingURL=api.js.map
